"use client";

import { Moon, Sun } from "lucide-react";

import { COMMON_COPY } from "copy/common";
import { useCopy } from "i18n/useCopy";

import { useTheme } from "../../../products/muggleTestV0/components/theme-provider";

import { Button } from "./ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";

export function ThemeToggle() {
  const copy = useCopy();
  const { theme, setTheme } = useTheme();

  const toggleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button variant="ghost" size="icon" onClick={toggleTheme}>
            {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>
            {theme === "dark"
              ? copy.text(COMMON_COPY.themeToggle.switchToLight)
              : copy.text(COMMON_COPY.themeToggle.switchToDark)}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
